import { IRoomRepository } from '../ports/IRoomRepository';
import { IGameLimitService } from '../ports/IGameLimitService';

export class CreateRoomUseCase {
  constructor(
    private roomRepo: IRoomRepository,
    private gameLimitService: IGameLimitService
  ) {}

  async execute(name: string, adminId: string, adminName: string, adminAnimal: string): Promise<string> {
    const hasReached = await this.gameLimitService.hasReachedLimit(adminId);
    if (hasReached) {
      throw new Error('Você atingiu o limite de 100 jogos por mês. Tente novamente no próximo mês!');
    }

    const roomId = await this.roomRepo.createRoom(name, adminId, adminName, adminAnimal);
    await this.gameLimitService.incrementCount(adminId);
    return roomId;
  }
}
